import React from 'react'
import { Page2019 } from '../organisms'
import { Section } from '../atoms'
import {
  Heading,
  Display,
  Content,
  Intro,
  image,
  LinkExternal,
} from '../../design-system/atoms'
import { IsoGrid } from '../graphics'

const PlaceholderImage = image({
  objectFit: 'cover',
  url: require('../../twt-core/graphics/crowd2.jpg'),
})

const AboutPage = () => (
  <Page2019 title="About">
    <Section bgGraphic={<IsoGrid width="100%" height="400px" />}>
      <Heading>About TWT</Heading>
      <Display>About TWT</Display>
      <Content>
        <p>
          <Intro>
            The World Transformed is supporting, developing and delivering
            political education across the UK in order to build a movement
            capable of radically transforming society.
          </Intro>
        </p>
        <p>
          We want to see the transformation of today’s society into one based on
          economic, environmental and social justice - a society where power is
          transferred from the establishment and into the hands of the many, and
          where oppression of all kinds is dismantled. We believe that electing
          a socialist government is a key part of this, but we know that truly
          transformative change can only be driven by the grassroots.
        </p>
        <p>
          As such, we need to build a mass, self-educating and politically
          conscious movement which is capable of electing and sustaining a
          radical government, as well as holding it to account. We need people
          of all ages and backgrounds to be engaged in political thinking and
          organising; to have a say in shaping the future of society. And we
          need this culture of collective political education to be embedded up
          and down the UK, across all spheres of society.
        </p>
        <p>
          Our annual 4-day festival of politics, arts and music began in 2016,
          and has since become the biggest political education event in the UK.
          While we cannot wait for the fourth edition of the festival to take
          place this September, we recognise that there’s only so much we can
          achieve in 4 days once a year. To realise our vision we need political
          education initiatives to be happening across the country all year
          round.
        </p>
        <p>
          See{' '}
          <LinkExternal href="https://2018.theworldtransformed.org/programme">
            here
          </LinkExternal>{' '}
          for information on the 2018 programme.
        </p>
        <p>
          <PlaceholderImage width="100%" padding={2} height="600px" />
        </p>
        <p>
          Our first festival in 2016 was funded by hundreds of small donations,
          and organised by a team of over 100 volunteers, who were inspired by
          the energy and enthusiasm of Jeremy Corbyn’s 2015 leadership campaign.
        </p>
        <p>
          Three years on, The World Transformed remains reliant on the efforts
          of hundreds of volunteers to make the festival happen, including
          around 20 core volunteers who put in time all year round to ensure the
          success of TWT. We try to ensure that no one is excluded from
          participating by covering all volunteer travel, accommodation and food
          expenses for the duration of the festival. We also aim to give people
          a choice in their roles as volunteers so that everyone gains something
          through taking part.
        </p>
        <p>
          As our organisation grows every year, so does our ability to hire paid
          staff. This year, that includes three year round members of staff, and
          five part-time project coordinators for the festival working from June
          to September, all paid at London Living Wage. As we continue to grow,
          we hope to start employing more people on higher wages, as well as
          expanding and putting more resources into our projects. We aim as we
          grow to be better able to pay for core and ongoing work that keeps the
          organisation running, and where possible we are prioritising raising
          funds to pay for work that is undervalued or precarious in wider
          society, such as arts and cultural work, care work and childcare.
        </p>
        <p>
          The World Transformed works with multiple partners every year whose
          goals and values are closely aligned with our own. We don’t take any
          money from big businesses, and none of our partners have any role in
          our governance structure. A full list of partners for TWT19 can be
          found below.
        </p>
      </Content>
    </Section>
  </Page2019>
)

export default AboutPage
